import HeaderLink from "./HeaderLink";
import PlainLink from "./PlainLink";

export function ConsentFragment() {
  return (
    <>
      <HeaderLink to="/Consent/index">Zgody</HeaderLink>

      <HeaderLink to="/Consent/EInvoice/index">E-faktury</HeaderLink>
      <PlainLink to="/Consent/EInvoice/index">Stan</PlainLink>
      <PlainLink to="/Consent/EInvoice/edit">Zmień</PlainLink>
      <PlainLink to="/Consent/EInvoice/history">Historia zmian</PlainLink>
    </>
  );
}
